import angular from 'angular'
import moment from 'moment'
import downloadBinToFile from '../../scripts/file_download'
import './styles.css'

export default function csvDownloads() {
  return {
    restrict: 'EA',
    template: require('./_csv_downloads.html'),
    controller: csvCtrl
  }
}

const domainAnalytics = 'domain_analytics'
const impact = 'impact'
const localStorageKeyDA = 'bundleNames'
const localStorageKeyImpact = 'impactBundles'

csvCtrl.$inject = ['$scope', 'analyticsApi', 'graph']
function csvCtrl($scope, analyticsApi, graph) {
  $scope.databaseToggle = 'redshift'
  $scope.allDomains = []
  graph.getDomains().then(function(res) {
    if (res.status === 'error') {
      // Handle error
    } else if (angular.isArray(res)) {
      $scope.allDomains = res
    }
  })

  // Set default dates
  let todaysDate = new Date()
  var endYear = todaysDate.getUTCFullYear()
  var startYear = endYear - 1
  $scope.redshiftImpactStartYear = endYear
  $scope.redshiftImpactStartMonth = todaysDate.getUTCMonth()
  $scope.redshiftImpactEndYear = endYear
  $scope.redshiftImpactEndMonth = todaysDate.getUTCMonth()
  var fullYear = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
  var halfYear = [7, 8, 9, 10, 11, 12]
  $scope.startMonthOptions = fullYear
  $scope.endMonthOptions = fullYear
  $scope.yearOptions = [startYear, endYear]
  $scope.combineDAReports = false

  $scope.refreshMonthOptions = function(isStart) {
    if (isStart) {
      if ($scope.redshiftImpactStartYear === startYear) {
        $scope.startMonthOptions = halfYear
      } else {
        $scope.startMonthOptions = fullYear
      }
    } else {
      if ($scope.redshiftImpactEndYear === startYear) {
        $scope.endMonthOptions = halfYear
      } else {
        $scope.endMonthOptions = fullYear
      }
    }
  }

  function dateStringFromYearMonth(year, month) {
    let date = new Date(`${year}-${month}-01`)
    return date.toISOString().split('T')[0]
  }

  $scope.startDate = moment([moment().year(), moment().month() - 1, 1]).format('YYYY-MM-DD')
  $scope.endDate = moment([moment().year(), moment().month() - 1, 1])
    .endOf('month')
    .format('YYYY-MM-DD')

  // Selectable school year
  $scope.schoolYears = (function() {
    var schoolYears = []
    var startingYear = 2020
    var currentYear = new Date().getFullYear()

    if (new Date().getMonth() < 6) {
      currentYear -= 1
    }

    for (; startingYear <= currentYear; startingYear++) {
      schoolYears.push({
        year: startingYear,
        label: ''.concat(startingYear, '-', startingYear - 1999)
      })
    }

    return schoolYears.reverse()
  })()

  $scope.selectedSchoolYear = $scope.schoolYears[0].year

  var reportFormat = {
    label: 'Excel Files (Zipped)',
    acceptType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    fileExtension: 'zip'
  }
  $scope.selectedDataDayFormat = reportFormat
  $scope.selectedDomainReportFormat = reportFormat

  $scope.d20DomainUuids = [
    '4ac80399-6ca8-48eb-778f-90bb11e799c0', // 180K The Seeall Academy (NYC District 20)
    '4d1fd77c-87a2-43cb-61e6-a154aa9069aa', // IS 30 Mary White Ovington (NYC District 20)
    '70a62667-2b1e-4165-5e0a-26f117e71012', // JHS 201 The Dyker Heights (NYC District 20)
    '5b01d047-4723-422b-6c54-00e5e3352bb0', // JHS 220 John J Pershing (NYC District 20)
    'e4439316-bc41-405b-48c6-e394f8e561c4', // JHS 62 Ditmas (NYC District 20)
    '01068551-b6c1-4068-6191-65d204fa71bf', // PS 102 The Bayview School (NYC District 20)
    '95e26003-7a37-46d1-6550-03188fb7192f', // PS 105 The Blythebourne (NYC District 20)
    'ed0bf1da-52c6-4cb2-442d-e67494c79f6b', // PS 112 Lefferts Park (NYC District 20)
    'ae6b1157-982d-446f-52ae-b6ef229ee48c', // PS 127 McKinley Park (NYC District 20)
    '92ab9163-5c16-4413-5249-34847e6bb16d', // PS 160 William T Sampson (NYC District 20)
    'c43cac82-128c-497f-63d2-9010fe912149', // PS 163 Bath Beach (NYC District 20)
    '23ccab03-6f9f-4d60-463b-fd7f52535690', // PS 179 Kensington (NYC District 20)
    'b163961d-3153-46b6-65ff-0cf0689f959a', // PS 185 Walter Kassenbrock (NYC District 20)
    '100a926d-af25-479f-40f5-03e484b87317', // PS 186 Dr Irving A Gladstone (NYC District 20)
    'd844428e-0527-4676-6c17-5fe77089da27', // PS 192 Magnet School for Math and Science Inquiry (NYC District 20)
    '33957b8f-c0cd-4185-52a0-f00e409507c1', // PS 200 Benson (NYC District 20)
    '7ddbd378-94b1-44ea-6be0-ab881b2ca4e0', // PS 204 Vince Lombardi (NYC District 20)
    '6473a9bf-a367-430d-7bc3-c7a3cbbf7a9e', // PS 205 Clarion (NYC District 20)
    '91120e39-e558-431d-726b-7815969fb8d4', // PS 229 Dyker (NYC District 20)
    'c388d3d0-bbcf-4cc3-4cb9-241a4661b8ca', // PS 247 (NYC District 20)
    '78dc343d-21ac-4908-77a9-2a5ad0a1ad6f', // PS 264 Bay Ridge Elementary School for the Arts (NYC District 20)
    '358ce68f-6fa0-4675-7fd7-f325bac93da2', // PS 310 (NYC District 20)
    '5c28c3a2-8dd6-4195-5f28-67ea7c5c927b', // PS 48 Mapleton (NYC District 20)
    'c81839fc-e597-4984-507c-2bacd4a4c7b1', // PS 506 The School of Journalism and Technology (NYC District 20)
    '41e1031f-6387-451e-5c68-02774ee00102', // PS 69 Vincent D Grippo School (NYC District 20)
    '641fb7d0-d4a3-4f7f-5ffe-8cfa79bca899', // PS 748: The Brooklyn School for Global Scholars (NYC District 20)
    '3243e58f-b3b6-4a0e-405d-0f50d0379ec3', // PS 971 (NYC District 20)
    '551d99ba-4a2d-48e1-7ae0-a92bebbcbba0' // The Academy of Talented Scholars (NYC District 20)
  ]

  $scope.texasDomainUuids = [
    '61ffbedf-60fa-4600-7aff-c7db866b4daa', // Alief ISD (TX)
    '1b9b2248-f2ab-461e-4ba7-beec7436181e', // Andrews ISD (TX)
    'dca84142-ea8e-4242-52fa-3903caa1b69a', // Belton ISD (TX)
    '6fe462a3-7e18-45c6-43bb-dd4a50b24b7a', // DeSoto ISD (TX)
    'b262251e-8187-4cbf-78fa-42ab23dfbe3b', // Hitchcock ISD (TX)
    '5e91de01-0907-4576-bf54-d7772f1a5407', // Houston Independent School District (TX)
    '86155b03-3521-4d04-427a-a5c90c256ec4', // Jarrell ISD (TX)
    'ccc7fb39-6991-4b8e-66be-95c5b697fd8b', // Midland Academy Charter School (TX)
    '75556a96-2d75-412f-5c5b-2808554f21a2', // Momentous Institute (TX)
    '5668c55c-a31a-4433-6461-016f5fb267b2', // Navarro ISD (TX)
    '00ea6309-a0e8-44c1-695c-bfb1bc610a2f', // New Braunfels ISD (TX)
    '0da3d5df-ed38-4075-4db8-7ec084066630', // San Antonio ISD (TX)
    'e266729e-201c-4bed-423f-3cd359139e7a', // Sheldon ISD (TX)
    'c35de1f7-3a2e-464d-72c3-5d392e65b6bd', // Southside ISD (TX)
    'b294a73d-d8d6-4711-4473-d9e7c4d49a96' // Universal Academy (TX)
  ]

  $scope.hawaiiDomainUuids = [
    '66b16cac-a4f7-45e5-4f6c-0d550500779f', // (North Hawai'i) Honokaa-Kealakehe-Kohala-Konawaena Complex Area
    '84409c39-0dd1-4ce9-4d27-a9bf0bbbc118', // (West Hawai'i) Honokaa-Kealakehe-Kohala-Konawaena Complex Area
    '79ea0298-9f80-486b-4f05-14f992a2433f', // Aiea-Moanalua-Radford Complex Area (HI)
    '9f65eb08-d85c-445d-5336-081095c7a86e', // Baldwin-Kekaulike-Maui Complex Area (HI)
    '965ff038-be1b-4a92-4356-100e011c8ca8', // Barbers Point Elementary School (CKCA) (HI)
    '767f6d7a-f460-4848-70f2-b56c42c3db3f', // Ewa Makai Middle School (HI)
    'f60a7027-244d-4c48-6cf1-0d1d1ad1ffe9', // Hana-Lahainaluna-Lanai-Molokai Complex Area (Canoe Complex- HI)
    '5db18f5f-c843-4209-5cbb-51f767ed380c', // Hilo-Waiakea Complex Area (Hawaii DOE) (HI)
    '589e86ce-dec8-4baf-4d29-7ed2a5bcab4a', // Honolulu District (Farrington-Kaiser-Kalani Complex Area, Kaimuki-McKinley-Roosevelt CA) (HI)
    'b42c189d-9f96-4606-4883-27a46c1b9043', // Ilima Intermediate School (CKCA) (HI)
    'b53f0e19-11e5-47b3-4ca4-d1ecc7fd8e7f', // Iroquois Point ES (CKCA) (HI)
    '64f09eec-59ed-45d6-4a26-b997d106afbe', // KA'U Learning Academy public Charter School (Kau-Keaau-Pahoa Complex Area)
    'e6176dee-d663-4341-4ae8-2e92e6d993b4', // Kaimiloa ES (CKCA) (HI)
    '316041a5-c70e-4e29-576b-fa14a4839bd8', // Kapaa-Kauai-Waimea Complex Area (HI)
    '0fd0aa97-7be8-4371-7b74-0ab9405f0833', // Kapolei High School (HI)
    '47aa63d8-36ce-42b2-afcb-2494dd34b9d7', // Kau-Keaau-Pahoa Complex Area (KKP) - (Hawaii DOE) (HI)
    '0a52d37e-84ad-4a85-5a9c-6715cbec657b', // Leilehua-Mililani-Waialua Complex Area (HI)
    '4a84aa34-9f76-4e53-4682-0406b4804b7b', // Pearl City High School (Hawaii Department of Education)
    'c3a7861b-1d7f-49fc-7f67-3c17af65695c', // Pohakea Elementary School (Campbell Kapolei Complex HI))
    'c7851407-005c-4586-7887-85d5a9cab869', // Waimalu Elementary School (Aiea-Moanalua-Radford Complex Area (HI))
    '37bb6d36-d9b4-4638-606d-7ed4d44434a5' // Windward District (HI)
  ]

  $scope.bundles = {}
  $scope.bundles[domainAnalytics] = {
    customBundleUuids: [],
    customBundleDomainUuidToName: {},
    customBundleName: 'New Bundle'
  }
  $scope.bundles[impact] = {
    customBundleUuids: [],
    customBundleDomainUuidToName: {},
    customBundleName: 'New Bundle'
  }
  getPreviousBundles()

  $scope.addDomainToBundle = function(domainUuid, domainName, reportType) {
    if ($scope.bundles[reportType].customBundleUuids.indexOf(domainUuid) === -1) {
      $scope.bundles[reportType].customBundleUuids.push(domainUuid)
      $scope.bundles[reportType].customBundleDomainUuidToName[domainUuid] = domainName
      if (reportType === domainAnalytics) {
        $scope.domainAnalyticsDomainForBundle = ''
      } else if (reportType === domainAnalytics) { 
        $scope.impactDomainForBundle = ''
      }
    }
  }

  $scope.removeDomainFromBundle = function(domainUuid, reportType) {
    var location = $scope.bundles[reportType].customBundleUuids.indexOf(domainUuid)
    if (location > -1) {
      $scope.bundles[reportType].customBundleUuids.splice(location, 1)
    }
  }

  function getPreviousBundles() {
    $scope.bundles[domainAnalytics].storedBundles = JSON.parse(localStorage.getItem(localStorageKeyDA)) || []
    $scope.bundles[impact].storedBundles = JSON.parse(localStorage.getItem(localStorageKeyImpact)) || []
    $scope.storedDABundleNames = Object.keys($scope.bundles[domainAnalytics].storedBundles)
    $scope.storedImpactBundleNames = Object.keys($scope.bundles[impact].storedBundles)
  }

  function storeCustomBundleInLocalStorage(reportType) {
    var localStorageKey = ''
    if (reportType === domainAnalytics) {
      localStorageKey = localStorageKeyDA
    } else if (reportType === impact) {
      localStorageKey = localStorageKeyImpact
    }
    var storedBundles = localStorage.getItem(localStorageKey)
    if (!storedBundles) {
      localStorage.setItem(localStorageKey, JSON.stringify({}))
    }
    storedBundles = localStorage.getItem(localStorageKey)
    storedBundles = JSON.parse(storedBundles)
    var customBundle = {
      uuids: $scope.bundles[reportType].customBundleUuids,
      names: $scope.bundles[reportType].customBundleDomainUuidToName,
      combined: $scope.combineDAReports
    }
    storedBundles[$scope.bundles[reportType].customBundleName] = customBundle
    localStorage.setItem(localStorageKey, JSON.stringify(storedBundles))
  }

  $scope.loadCustomBundle = function(reportType) {
    var selectedBundle = ''
    if (reportType === domainAnalytics) {
      selectedBundle = $scope.selectedDABundle
    } else if (reportType === impact) {
      selectedBundle = $scope.selectedImpactBundle
    }
    if (selectedBundle === null) {
      $scope.bundles[reportType].customBundleName = 'New Bundle'
      $scope.bundles[reportType].customBundleUuids = []
      $scope.bundles[reportType].customBundleDomainUuidToName = {}
    } else {
      $scope.bundles[reportType].customBundleName = selectedBundle
      $scope.bundles[reportType].customBundleUuids = $scope.bundles[reportType].storedBundles[selectedBundle].uuids || []
      $scope.bundles[reportType].customBundleDomainUuidToName = $scope.bundles[reportType].storedBundles[selectedBundle].names || {}
      if (reportType === domainAnalytics) {
        $scope.combineDAReports = !!$scope.bundles[reportType].storedBundles[selectedBundle].combined
      }
    }
  }

  $scope.downloadCustomBundle = function(schoolYear, reportType) {
    storeCustomBundleInLocalStorage(reportType)
    getPreviousBundles()
    if (reportType === domainAnalytics) {
      $scope.downloadDomainReport($scope.bundles[reportType].customBundleUuids, schoolYear, $scope.bundles[reportType].customBundleName)
    } else if (reportType === impact) {
      $scope.downloadImpactReport($scope.bundles[reportType].customBundleUuids, $scope.bundles[reportType].customBundleName)
    }
  }

  $scope.downloadDataDay = function() {
    var format = angular.copy($scope.selectedDataDayFormat)
    var params = {}
    if ($scope.databaseToggle) {
      params.database = $scope.databaseToggle
    }
    analyticsApi
      .getDomainReports(params, { Accept: format.acceptType }, '')
      .then(function(data, status, headers, config) {
        downloadBinToFile(data, 'data_day.'.concat(format.fileExtension), format.acceptType)
      })
  }

  $scope.downloadDomainLicenseCounts = function(product) {
    var format = angular.copy($scope.selectedDataDayFormat)
    var params = { product: product }
    analyticsApi
      .getAnalyticsReport('domain_license_counts', params, 'xlsx', {
        sdate: '0001-01-01',
        edate: '0001-01-01',
        database: 'rds'
      })
      .then(function(data, status, headers, config) {
        downloadBinToFile(
          data,
          `domain_${product}_license_counts.${format.fileExtension}`,
          format.acceptType
        )
      })
  }

  $scope.downloadLMSEnabledDomains = function() {
    var format = angular.copy($scope.selectedDataDayFormat)
    analyticsApi
      .getAnalyticsReport(
        'domains_lms_enabled',
        {
          sdate: '0001-01-01',
          edate: '3000-01-01',
          database: 'mongo'
        },
        'xlsx'
      )
      .then(function(data, status, headers, config) {
        downloadBinToFile(data, `lms_enabled_domains.${format.fileExtension}`, format.acceptType)
      })
  }

  $scope.downloadDomainReport = function(domainUuids, schoolYear, bundleName) {
    var format = angular.copy($scope.selectedDomainReportFormat)
    var sDate = schoolYear + '-07-01'
    var eDate = parseInt(schoolYear) + 1 + '-07-01'
    var reportType = 'domain_analytics'

    if (Array.isArray(domainUuids)) {
      reportType = $scope.combineDAReports
        ? 'combined_domain_analytics'
        : 'multiple_domain_analytics'
    }
    analyticsApi
      .getReport(
        reportType,
        Array.isArray(domainUuids) ? domainUuids.join(',') : domainUuids,
        sDate,
        eDate,
        $scope.databaseToggle
      )
      .then(function(data, status, headers, config) {
        downloadBinToFile(data, bundleName + ' Domain Analytics.zip', format.acceptType)
      })
  }

  $scope.downloadImpactReport = function(domainUuids, bundleName) {
    if (!domainUuids) {
      alert('Please select a domain')
      return
    }
    let sDate = $scope.startDate
    let eDate = $scope.endDate
    if ($scope.databaseToggle) {
      sDate = dateStringFromYearMonth(
        $scope.redshiftImpactStartYear,
        $scope.redshiftImpactStartMonth
      )
      eDate = dateStringFromYearMonth($scope.redshiftImpactEndYear, $scope.redshiftImpactEndMonth)
    }
    let reportType = 'all'
    let promise = {}
    let defaultFilename = 'impact_reports.zip'
    let filename = bundleName ? bundleName + '_' + defaultFilename : defaultFilename
    if (Array.isArray(domainUuids)) {
      promise = analyticsApi
        .getReportPost(reportType, domainUuids, sDate, eDate, $scope.databaseToggle)
    } else {
      promise = analyticsApi
        .getReport(reportType, domainUuids, sDate, eDate, $scope.databaseToggle)
    }
    promise.then(function(data, status, headers, config) {
      downloadBinToFile(data, filename, 'application/zip')
    })
  }
}
